import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { patchDriversDHTLimits } from '../../services/DriversService';
import { DHTLimitsResponse, DHTLimits } from '../../types/Drivers';

type Result = UseMutationResult<DHTLimits, Error, DHTLimitsResponse>;

function usePatchDHTLimits(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(patchDriversDHTLimits, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['drivers-dht'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePatchDHTLimits;
